/** Package version - Is set in rollup.config.js */
var VERSION = "b1d71"; // e.g. c2ee7 for shared version 2.3.2
var prefix = "-".concat(VERSION); // -c2ee7
/** Prefix for components of lsg.shared [lsgs-xxxxx--] */
var lsgPre = "lsgs".concat(prefix, "--"); // lsgs-c2ee7--
/** Prefix for legacy components of lsg.components (yet not wrapped from shared) [lsg-xxxxx--] */
var lsgPreComp = "lsg".concat(prefix, "--"); // lsg-c2ee7--
/** Prefix for components of lsg.shared that are used globally (like Theme) [lsg-xxxxx---] */
var lsgPreGlobal = "lsg".concat(prefix, "---"); // lsg-c2ee7---
/** In some places we need the current version of shared as MD5 */
var versionAsMd5 = "".concat(VERSION) || ""; // c2ee7

export { lsgPre, lsgPreComp, lsgPreGlobal, versionAsMd5 };
